// This WebAudioEncoderImpl is needed for Safari for now, because Safari doesn't
// yet support the WebCodecs audio API.
import EventEmitter from 'eventemitter3';
import { PolyfillOpusEncoder } from './PolyfillOpusEncoder';
import { WebAudioRecorder } from './WebAudioRecorder';
export class WebAudioEncoderImpl {
    emitter;
    webAudioRecorder;
    polyfillOpusEncoder;
    constructor() {
        this.emitter = new EventEmitter();
        this.polyfillOpusEncoder = new PolyfillOpusEncoder();
        this.polyfillOpusEncoder.emitter.on('audioData', (encodedAudioData) => {
            this.emitter.emit('audioData', encodedAudioData);
        });
        this.webAudioRecorder = new WebAudioRecorder();
    }
    async start(audioTrack) {
        console.log('WebAudioEncoderImpl::start()', audioTrack);
        await this.polyfillOpusEncoder.init();
        this.webAudioRecorder.on('data', async (timestampMicros, samples) => {
            this.polyfillOpusEncoder.encode(timestampMicros, samples);
        });
        await this.webAudioRecorder.start(audioTrack);
    }
    stop() {
        console.log('WebAudioEncoderImpl stop');
        this.webAudioRecorder.stop();
    }
}
